<template>
  <div id="app" :key="$route.fullPath" :class="'app_' + event_id + '_' + getCurrentLang()">
    <under-maintenance v-if="web_switch && !isDEV" />
    <template v-else>
      <div class="app-window" v-if="web_pc_config.window_status == 2 && !close">
        <i class="el-icon-circle-close app-close" @click.stop="close = true"></i>
        <el-image
          @click="clickWindowImg(window_url)"
          style="width: 100%; height: 100%"
          :src="baseURL + web_pc_config.window_image"
          fit="fit"></el-image>
      </div>
      <BHCarousel :swiperList="carousel_img"></BHCarousel>
      <template v-if="bilingual == 'en' && event_id != 1968 && web_pc_config.show_btn == 1">
        <div class="Lang" v-if="!carousel_img.length">
          <div class="Lang_content">
            <Lang :switchColor="switchColor" />
          </div>
        </div>
        <Lang :switchColor="switchColor" v-else />
      </template>
      <router-view :key="$route.fullPath" />
    </template>
    <div
      class="dzBtn"
      :class="'dzBtn' + event_id"
      @click="changeEnd"
      v-if="event_id == 1565 || event_id == 1594 || event_id == 1747 || event_id == 1740">
      {{ $route.query.event_id == 1747 || $route.query.event_id == 1968 ? '中文' : 'ENG' }}
    </div>

    <div class="dzBtn" :class="'dzBtn' + event_id" @click="dzBtnAiOpen" v-if="event_id == 1826">
      <img
        width="100%"
        src="https://pxsp.iceriverbj.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20261231230122095320_36.png"
        alt="" />
    </div>
    <AIAssistantModal v-if="showAIAssistant" @close="showAIAssistant = false" />
    <!-- 定制 -->
  </div>
</template>

<script>
import { getPcConfig, getEventInfo, webmodelDetail, getPageList } from '@/api/index';
import UnderMaintenance from '@/components/under-maintenance.vue';
import BHCarousel from '@/components/bh-carousel';
import Lang from '@/components/Lang';
import AIAssistantModal from '@/components/AIAssistantModal.vue';
import { setLocale } from './lang';
import { getCurrentLang } from '@/lang/utils/i18n-util';
import wxShare from '@/utils/wxShare';

export default {
  name: 'app',
  components: {
    UnderMaintenance,
    BHCarousel,
    Lang,
    AIAssistantModal,
  },
  data() {
    return {
      showAIAssistant: false,
      baseURL: process.env.VUE_APP_BASE_API,
      isDEV: encodeURI(window.location.href.split('#')[0]) === 'http://localhost:8050/',
      event_id: undefined,
      web_switch: false, // 是否是在维护中
      ad_switch: 1, // 是否开启广告
      close: false, // false 是开，true 是关
      allConfigs: { web_config: {} },
      switch_color: '#373AB5',
      bilingual: 'zh',
    };
  },
  provide() {
    return {
      allConfigs: () => this.allConfigs,
    };
  },
  computed: {
    switchColor() {
      const root = document.documentElement;
      root.style.setProperty('--color1', this.allConfigs.web_pc_config?.switch_color);
      return this.allConfigs.web_pc_config?.switch_color;
    },
    carousel_img() {
      const images = this.allConfigs.web_pc_config?.carousel_img || '[]';
      return JSON.parse(images);
    },
    window_url() {
      return this.$Base64.decode(this.allConfigs.web_pc_config.window_url);
    },
    web_pc_config() {
      return this.allConfigs.web_pc_config || { window_status: 1 };
    },
  },
  created() {
    this.event_id = JSON.parse(localStorage.getItem('event_id'));
    if (
      window.screen.width < 768 &&
      this.event_id != 1968 &&
      this.event_id != 2149 &&
      this.event_id != 2185
    )
      return (location.href = `/mobile${
        process.env.VUE_APP_BASE_API == 'https://pay-pre.iceriverbj.com/' ? 'test' : ''
      }/#/${this.event_id}?lang=${getCurrentLang()}`);

    if (
      this.event_id == 1594 ||
      this.event_id == 1745 ||
      this.event_id == 1747 ||
      this.event_id == 1968
    ) {
      setLocale('en');
    } else {
      // console.log(getCurrentLang());
      // setLocale('zh');
    }

    if (this.event_id == 2159) {
      this.$alert(
        '<span style="font-size: 16px;color:#1F2329">温馨提示：如24日12:30之后报到，也可直接前往【绍兴市人民医院镜湖总院-科教楼】报到（绍兴市白鱼潭路123号）</span>',
        { confirmButtonText: '确定', dangerouslyUseHTMLString: true },
      );
    }

    this.getPcConfig();
    this.getEventInfo();

    this.webmodelDetail();
  },
  mounted() {
    // if (this.event_id == 1826) {
    //   const script = document.createElement('script');
    //   script.src = 'https://o.alicdn.com/appflow/chatbot/v1/AppflowChatSDK.js';
    //   script.onload = () => {
    //     window.APPFLOW_CHAT_SDK.init({
    //       integrateConfig: {
    //         integrateId: 'cit-fcd285bdfb4d42ca93d0',
    //         domain: {
    //           requestDomain: 'https://1095231984469331.appflow.aliyunnest.com',
    //         },
    //       },
    //     });
    //   };
    //   document.body.appendChild(script);
    // }
  },
  methods: {
    async webmodelDetail() {
      try {
        // const res = await getPageList({
        //   event_id: this.event_id,
        // });
        // const res2 = await webmodelDetail({
        //   event_id: this.event_id,
        //   page_id: res.data[0].id,
        // });

        if (this.event_id == 2185) {
          wxShare({
            title:
              'East Lake Conference Symposium on Low-Dimensional Quantum Materials and Devices',
            desc: '',
            link: '',
            imgUrl: 'https://pay.iceriverbj.com//uploads/69dc68568f56a-1776052310-首图.jpg',
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    dzBtnAiOpen() {
      this.showAIAssistant = !this.showAIAssistant;
    },
    async getEventInfo() {
      let id = this.event_id;
      let { code, data } = await getEventInfo({ id });
      if (code == 1) {
        this.bilingual = data.lang;
        this.$store.commit('SET_BILINGUAL', data.lang);
        if (this.$route.query.lang == 'en') {
          document.title = data.name_en;
        }
      }
    },
    changeEnd() {
      if (this.event_id == 1594) {
        window.location.href = 'https://website.iceriverbj.com/pc/#/?event_id=1565&lang=zh';
        location.reload();

        return;
      } else if (this.event_id == 1565) {
        window.location.href = 'https://website.iceriverbj.com/pc/#/?event_id=1594&lang=zh';
        location.reload();

        return;
      } else if (this.event_id == 1747) {
        window.location.href = 'https://website.iceriverbj.com/pc/#/?event_id=1740&lang=zh';
        location.reload();

        return;
      } else if (this.event_id == 1740) {
        window.location.href = 'https://website.iceriverbj.com/pc/#/?event_id=1747&lang=zh';
        location.reload();

        return;
      }
      const newLang = getCurrentLang() == 'zh' ? 'en' : 'zh';
      setLocale(newLang);
      sessionStorage.pcMicroSiteEditLang = newLang;
      this.$router.push({
        query: {
          ...this.$route.query,
          lang: newLang,
        },
      });
      location.reload();
      // if (this.event_id == 1594) {
      // } else {
      //   setLocale('zh');
      // }
      // this.getPcConfig();
    },
    getCurrentLang,
    clickWindowImg(url) {
      if (!url) return;
      window.open(url, '_blank');
    },
    // 获取PC端网站配置
    async getPcConfig() {
      try {
        const res = await getPcConfig({ event_id: this.event_id });
        console.log('🚀 ~ getPcConfig ~ res:', res);
        this.allConfigs = res.data;

        if (this.allConfigs?.web_pc_config?.website_switch === '1') {
        } else {
          return this.$router.push('/404');
        }
        this.initWebConfig(res.data?.web_config);
      } catch (error) {
        console.log(error);
      }
    },
    // 初始化网站配置
    initWebConfig(web_config = {}) {
      const { web_switch, web_icon, event_title } = web_config;
      // 网站是否启用
      if (web_switch == 2 || web_switch == 1) {
        this.web_switch = false;
      } else {
        this.web_switch = false;
      }
      // 网站icon
      var link = document.createElement('link');
      link.id = 'myFavicon';
      link.rel = 'icon';
      link.href = this.baseURL + web_icon; // 新图标URL
      document.getElementsByTagName('head')[0].appendChild(link);
      // 网站标题
      document.title = event_title;
    },
  },
};
</script>

<style lang="scss">
// html {
//   font-size: 23.36px;
// }
body,
html {
  width: 100%;
  height: 100%;
  overflow: auto;
}

body {
  padding: 0;
  margin: 0;
  font: 14px tahoma, arial, \5b8b\4f53;
  // font-size: 100%;
  // font-size: 100%;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}

ul,
ol {
  list-style: none;
}

a {
  text-decoration: none;
}

:root {
  --bg: #28469c;
  --shadow: rgba(29, 80, 162, 0.3);
}

#app {
  position: relative;
  font-family: Microsoft YaHei, 黑体, Arial, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}

.app-window {
  width: 100px;
  height: 100px;
  background: #fff;
  border-radius: 8px;
  padding: 8px;
  position: fixed;
  left: 10px;
  top: 150px;
  z-index: 1000;

  .app-close {
    position: absolute;
    right: 9px;
    top: 12px;
    font-size: 14px;
    cursor: pointer;
    z-index: 10000;
    color: #333333;
  }
}

.Lang {
  // width: 1159px;
  height: 62px;
  background-color: #eaf2fa;

  .Lang_content {
    width: 1159px;
    margin: 0 auto;
    position: relative;

    .Main_lang {
      right: 0;
    }
  }
}

.dzBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55px;
  height: 55px;
  position: fixed;
  background-color: #2a3cb7;
  right: 14%;
  bottom: 29%;
  cursor: pointer;
  border-radius: 50%;
  color: #fff;
  box-shadow: 0px 1px 7px 1px rgba(46, 89, 199, 0.05);
}

.dzBtn1826 {
  right: 8%;
  bottom: 10%;
  width: 55px;
  box-shadow: none;
  background-color: unset;
}

.dzBtn1747,
.dzBtn1740 {
  bottom: 0;
  top: 515px;
  right: 8%;

  background-color: #4ea29e;
}
</style>

<style lang="scss">
.app_2185_en {
  .content > div {
    width: 90% !important;
    min-width: 1159px;
  }
  .r-title {
    display: none;
  }
  .haveday {
    display: none;
  }

  .right-item {
    width: 351px !important;
    padding: 0 !important;
    margin-right: 35px;
    box-shadow: none !important;
    border: 1px solid #4ea2e4 !important;
    margin-left: 0px !important;
    margin-top: 30px;
    &:first-child {
      padding: 10px !important;
    }
  }

  .important-time {
    padding: 1px !important;
    margin: 0 !important;

    .ql-editor {
      padding: 0;
    }
  }

  .footer-box {
    padding: 0 !important;
  }
  .content .left {
    background-color: #f2f2f2 !important;
    box-shadow: none !important;
  }

  .bread-crumbs {
    display: none !important;
  }

  .content {
    background: #fff;
  }

  .left-main {
    background-image: url(https://pxsp.iceriverbj.com/%E7%BD%91%E7%AB%99%E5%BA%95%E5%9B%BE1231242345235.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
  }

  .right {
    background-color: #f2f2f2;
  }
}
</style>
